/**
* OpenAM get device script
**/
function device() {
      /*
     * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS HEADER.
     *
     * Copyright (c) 2009 Sun Microsystems Inc. All Rights Reserved
     *
     * The contents of this file are subject to the terms
     * of the Common Development and Distribution License
     * (the License). You may not use this file except in
     * compliance with the License.
     *
     * You can obtain a copy of the License at
     * https://opensso.dev.java.net/public/CDDLv1.0.html or
     * opensso/legal/CDDLv1.0.txt
     * See the License for the specific language governing
     * permission and limitations under the License.
     *
     * When distributing Covered Code, include this CDDL
     * Header Notice in each file and include the License file
     * at opensso/legal/CDDLv1.0.txt.
     * If applicable, add the following below the CDDL Header,
     * with the fields enclosed by brackets [] replaced by
     * your own identifying information:
     * "Portions Copyrighted [year] [name of copyright owner]"
     *
     */
    /*
     * Portions Copyrighted 2013 Syntegrity.
     * Portions Copyrighted 2013-2014 ForgeRock AS.
     */

    getDateOffset = function() {
   	var currDt = new Date();
	var jan = new Date(currDt.getFullYear(), 0, 1);
    	var jul = new Date(currDt.getFullYear(), 6, 1);
    	return Math.max(jan.getTimezoneOffset(), jul.getTimezoneOffset());
    },	
    collectTimezoneInfo = function () {
            var timezoneInfo = {};
	    var offset = getDateOffset();		
            if (offset) {
                timezoneInfo.timezone = offset;
            } else {
                console.warn("Cannot collect timezone information. timezone is not defined.");
            }

            return timezoneInfo;
        },
    collectBrowserPluginsInfo = function () {
            if (navigator && navigator.plugins) {
                var pluginsInfo = {}, i, plugins = navigator.plugins;
                pluginsInfo.installedPlugins = "";
                return pluginsInfo;
            } else {
                console.warn("Cannot collect browser plugin information. navigator.plugins is not defined.");
                return {};
            }

        },
    collectBrowserFontsInfo = function () {
            var fontsInfo = {}, i, fontsList = ["cursive", "monospace", "serif", "sans-serif", "fantasy", "default", "Arial", "Arial Black",
                "Arial Narrow", "Arial Rounded MT Bold", "Bookman Old Style", "Bradley Hand ITC", "Century", "Century Gothic",
                "Comic Sans MS", "Courier", "Courier New", "Georgia", "Gentium", "Impact", "King", "Lucida Console", "Lalit",
                "Modena", "Monotype Corsiva", "Papyrus", "Tahoma", "TeX", "Times", "Times New Roman", "Trebuchet MS", "Verdana",
                "Verona"];
            fontsInfo.installedFonts = "";
      
            return fontsInfo;
        },


    devicePrint = {};

    devicePrint.screen = {};
    devicePrint.timezone = collectTimezoneInfo();
    devicePrint.plugins = collectBrowserPluginsInfo();
    devicePrint.fonts = collectBrowserFontsInfo();

    if (navigator.userAgent) {
        devicePrint.userAgent = navigator.userAgent;
    }
    if (navigator.appName) {
        devicePrint.appName = navigator.appName;
    }
    if (navigator.appCodeName) {
        devicePrint.appCodeName = navigator.appCodeName;
    }
    if (navigator.appVersion) {
        devicePrint.appVersion = navigator.appVersion;
    }
    if (navigator.platform) {
        devicePrint.platform = navigator.platform;
    }
    if (navigator.cpuClass) {
        devicePrint.cpuClass = navigator.cpuClass;
    }
    if (navigator.oscpu) {
        devicePrint.oscpu = navigator.oscpu;
    }
    if (navigator.product) {
        devicePrint.product = navigator.product;
    }
    if (navigator.vendor) {
        devicePrint.vendor = navigator.vendor;
    }
    if (navigator.language) {
        devicePrint.language = navigator.language;
    }
    if (navigator.browserLanguage) {
        devicePrint.browserLanguage = navigator.browserLanguage;
    }
    if (navigator.systemLanguage) {
        devicePrint.systemLanguage = navigator.systemLanguage;
    }

    devicePrint.geolocation = {};
  
    return JSON.stringify(devicePrint);
}